import React from 'react';
import PropTypes from 'prop-types';

const imageFocus = [
    'image-position-center',
    'image-position-left',
    'image-position-top',
    'image-position-right',
    'image-position-bottom'
];

export default class NewsArticleItem extends React.PureComponent {

    render() {
        let item = this.props.item;

        return (
            <div className="card">
                <div className="card__img news-article-item__img">
                    <img data-srcset={item.image.srcSet} data-sizes="auto"
                         className={`lazyload ${imageFocus[item.image.imageFocus]}`} alt={item.title}/>
                    <a href={item.url}/>
                </div>
                <div className="card__content">
                    <div className="card__title">
                        <a href={item.url}>{item.title}</a>
                    </div>
                    <div className="card__text">
                        {item.summary}
                    </div>
                    <div className="card__bottom">
                        <a className="link card__link" href={item.url}>
                            read more
                            <svg width="5" height="9" className="icon icon--after">
                                <use xlinkHref="#icon-arrow-right"></use>
                            </svg>
                        </a>
                        <div className="news-article-item__date" dangerouslySetInnerHTML={{__html: item.datePublished}}>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NewsArticleItem.propTypes = {
    item: PropTypes.object.isRequired
};





// WEBPACK FOOTER //
// ./app/components/news-article-item/js/NewsArticleItem.js